<script lang="ts">
  type DesignSectionItem = {
    id: string;
    label: string;
    icon: string;
  };

  let {
    sections = [],
    activeSection = 'theme',
    onSelect = (_id: string) => {},
  }: {
    sections?: readonly DesignSectionItem[];
    activeSection?: string;
    onSelect?: (id: string) => void;
  } = $props();
</script>

<aside class="rounded-[1.75rem] border border-default bg-surface p-3 shadow-sm">
  <div class="flex flex-col gap-2">
    {#each sections as section}
      <button
        type="button"
        class={`flex h-14 w-[4.5rem] flex-col items-center justify-center rounded-2xl p-1 text-xs transition ${
          activeSection === section.id
            ? 'bg-gray-200 dark:bg-dark-elevated text-content'
            : 'text-content-secondary hover:bg-gray-100 dark:hover:bg-dark-tertiary hover:text-gray-900 dark:hover:text-dark-text-high'
        }`}
        onclick={() => onSelect(section.id)}
      >
        <span class="text-lg leading-none">{section.icon}</span>
        <span class="mt-1 font-medium">{section.label}</span>
      </button>
    {/each}
  </div>
</aside>
